export const getEventTypeLabel = (eventType) => {
  switch (eventType) {
    case 'A':
      return 'TRLT_UI-INSERTION_REQUEST';
    case 'E':
      return 'TRLT_UI-MODIFICATION_REQUEST';
    case '6':
      return 'TRLT_UI-REVOKED_REQUEST';
    case '4':
      return 'TRLT_UI-REVOKED';
    case '0':
      return 'TRLT_UI-ACCEPTED';

    default:
      return '';
  }
};
